import { useState, useEffect, useCallback } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Loader2, Mail, CheckCircle2, RotateCcw, Inbox } from "lucide-react";

export default function AdminSupportPanel() {
  const [tickets, setTickets] = useState(null);

  const load = useCallback(() => {
    api.get("/admin/support/tickets").then((r) => setTickets(r.data)).catch(() => setTickets([]));
  }, []);

  useEffect(() => { load(); }, [load]);

  const toggle = async (t) => {
    const ns = t.status === "open" ? "resolved" : "open";
    await api.patch(`/admin/support/tickets/${t.id}`, { status: ns });
    load();
  };

  if (!tickets) return <div className="flex justify-center p-6" data-testid="support-loading"><Loader2 className="h-5 w-5 animate-spin" /></div>;

  const open = tickets.filter((t) => t.status !== "resolved").length;

  return (
    <div className="space-y-4" data-testid="admin-support-panel">
      <div className="flex items-center justify-between">
        <p className="text-sm text-muted-foreground">Správy od zákazníkov. Otvorené: <span className="font-semibold text-foreground">{open}</span> · Spolu: {tickets.length}</p>
        <Button variant="ghost" size="sm" onClick={load} data-testid="support-refresh">Obnoviť</Button>
      </div>

      {tickets.length === 0 && (
        <div className="flex flex-col items-center gap-2 rounded-xl border border-border bg-card/60 p-10 text-center text-muted-foreground" data-testid="support-empty">
          <Inbox className="h-8 w-8" /> Zatiaľ žiadne správy.
        </div>
      )}

      <div className="space-y-3">
        {tickets.map((t) => (
          <div key={t.id} className={`rounded-xl border p-4 ${t.status === "resolved" ? "border-border bg-muted/30 opacity-70" : "border-primary/30 bg-card/60"}`} data-testid="support-ticket">
            <div className="flex flex-wrap items-start justify-between gap-2">
              <div className="min-w-0">
                <a href={`mailto:${t.email}`} className="flex items-center gap-1.5 font-semibold text-primary hover:underline" data-testid="support-ticket-email"><Mail className="h-4 w-4" />{t.email}</a>
                <div className="text-xs text-muted-foreground">{t.name || "—"} · {(t.created_at || "").slice(0, 16).replace("T", " ")} · {t.page_url || "—"}</div>
              </div>
              <Button size="sm" variant={t.status === "resolved" ? "ghost" : "default"} onClick={() => toggle(t)} data-testid="support-ticket-toggle">
                {t.status === "resolved" ? <><RotateCcw className="mr-1 h-4 w-4" />Znovu otvoriť</> : <><CheckCircle2 className="mr-1 h-4 w-4" />Vyriešené</>}
              </Button>
            </div>
            <p className="mt-3 whitespace-pre-wrap text-sm text-foreground">{t.message}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
